export default [
    {
        path: ':id',
        name: 'pages.show',
        component: () => import('@/views/page/Show.vue'),
    },
]